export const MONTHS = [
  { n: 1, nama: "Januari", short: "Jan" },
  { n: 2, nama: "Februari", short: "Feb" },
  { n: 3, nama: "Maret", short: "Mar" },
  { n: 4, nama: "April", short: "Apr" },
  { n: 5, nama: "Mei", short: "Mei" },
  { n: 6, nama: "Juni", short: "Jun" },
  { n: 7, nama: "Juli", short: "Jul" },
  { n: 8, nama: "Agustus", short: "Ags" },
  { n: 9, nama: "September", short: "Sep" },
  { n: 10, nama: "Oktober", short: "Okt" },
  { n: 11, nama: "November", short: "Nov" },
  { n: 12, nama: "Desember", short: "Des" },
];

export function fmtPct(v) {
  if (v === null || v === undefined) return "N/A";
  return `${(v * 100).toFixed(1)}%`;
}

export function statusBg(cap, target) {
  if (cap === null || cap === undefined || target === null || target === undefined) return "";
  return cap >= target
    ? "bg-emerald-100 text-emerald-800"
    : "bg-rose-100 text-rose-800";
}

export function statusBorder(cap, target) {
  if (cap === null || cap === undefined || target === null || target === undefined) return "bg-slate-50 text-slate-400";
  return cap >= target ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700";
}
